export default function NotImplemented() {
  return (
    <div className="flex h-28 w-full items-center justify-center bg-eggshell text-2xl font-bold">
      This slice is not implemented.
    </div>
  );
}
